<template>
    <div class="form-group">
        <FormLabel>{{ label }}</FormLabel>
        <p>{{ formattedValue }}</p>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";

export default {
    name: "FormConfirm",
    components: { FormLabel },
    props: {
        label: {
            type: String,
        },
        value: {
            type: [String, Number, Array],
            default: ''
        }
    },
    computed: {
        formattedValue() {
            if (Array.isArray(this.value)) {
                return this.value.join(', '); // 配列の場合はカンマ区切りの文字列に変換
            }
            return this.value.toString(); // 単一のStringまたはNumberの場合はそのまま表示
        }
    }
}
</script>

<style scoped>
/* スタイルをここに追加 */
</style>
